import { DrugSource } from '@/models/Drug/DrugProduct';
import Axios from 'axios';

/** True when the drug's source can produce a product image. */
export function supportsDrugImages(source: DrugSource | null | undefined): boolean {
    return source === DrugSource.GsddFederal;
}

/**
 * Builds the product image URLs for a drug, or an empty array when the drug's source can never
 * resolve an image. Only GSDD drugs have images available; the endpoint returns 404 for every
 * other source, so callers should skip the request entirely rather than render a broken image.
 */
export function getDrugImageUrls(drugId: number | null | undefined, source: DrugSource | null | undefined): string[] {
    if (!drugId || !supportsDrugImages(source)) return [];

    const baseURL = Axios?.defaults?.baseURL || '';
    return [`${baseURL}/drug/get-image?packageID=${drugId}&drugSource=${source}`];
}
